const stagingCpcCardConfig = {
  9724: {
    title:
      'Based on your answers, we have matched you to a CRM software supplier best suited to you:',
    cardUrl: '/cpc-card-assets/cpc-card-crm-us.html',
    questions: {
      'a2f8b4ab-f96c-11e4-824b-22000a699fb3': ['No'],
      'a7e862c0-fbe9-11e5-9ebe-22000b0a2127': ['1-4', '5-19'],
    },
  },
  9829: {
    title:
      'Based on your answers we have matched you to a field service software supplier best suited to you:',
    cardUrl: '/cpc-card-assets/cpc-card-field-service-software-us.html',
    questions: {
      'a2f8b4ab-f96c-11e4-824b-22000a699fb3': ['No'],
      '141d4305-5081-11e9-9971-027d6fa66c86': ['1 - 4'],
    },
  },
  9830: {
    title:
      'Based on your answer we have matched you to the following website builders:',
    cardUrl: '/cpc-card-assets/cpc-card-web-design-us.html',
    questions: {
      'a2f8b4ab-f96c-11e4-824b-22000a699fb3': ['No'],
    },
  },
  9882: {
    title:
      'Based on your answers, we have matched you to these Payroll Services suppliers:',
    cardUrl: '/cpc-card-assets/cpc-card-approved-payroll-services.html',
    questions: {
      'c71e3460-d1e3-11e3-aa27-22000a699fb3': ['3 - 10', 'Under 3'],
    },
  },
  9884: {
    title:
      'Based on your answers, you’re eligible to buy Eargo’s product online. Click ‘Visit Store’ to go to the Eargo shop.',
    cardUrl: '/cpc-card-assets/cpc-card-hearing-aids-us.html',
    questions: {
      '8b7f2fe0-8eb3-11e9-9e05-027d6fa66c86': ['45 or under', '46 to 55'],
      'c5dd8a2d-8eb3-11e9-9e05-027d6fa66c86': ['Yes', 'No'],
    },
  },
  10001: {
    title:
      "We're sorry! Our partners only offer free hearing tests for people aged 55+",
    subheading: 'Have you considered these hearing loss prevention products?',
    cardUrl: '/cpc-card-assets/cpc-card-hearing-aids-uk.html',
    questions: {
      '0bc7162a-f469-11e6-b2c5-022a69d30eef': ['45 or under', '46 to 55'],
      'fa0c6e86-dbd9-11ea-a252-027d6fa66c86': ['Male', 'Female'],
      '782e8d73-84e2-11ec-a6b2-062f1bcd6de3': [
        'Very Mild',
        'Mild',
        'Moderate',
        'Severe',
        'Very Severe',
      ],
    },
  },
};

const cpcCardConfig = {
  development: stagingCpcCardConfig,
  staging: stagingCpcCardConfig,
  test: stagingCpcCardConfig,
  'production-eu': {
    14927: {
      title:
        'Based on your answers, we have matched you to these Payroll Services suppliers:',
      cardUrl: '/cpc-card-assets/cpc-card-approved-payroll-services.html',
      questions: {
        'c71e3460-d1e3-11e3-aa27-22000a699fb3': ['3 - 10', 'Under 3'],
      },
    },
    15267: {
      title:
        "We're sorry! Our partners only offer free hearing tests for people aged 55+",
      subheading: 'Have you considered these hearing loss prevention products?',
      cardUrl: '/cpc-card-assets/cpc-card-hearing-aids-uk.html',
      questions: {
        'eba10291-6797-11ea-9e05-027d6fa66c86': ['44 or under', '45 to 55'],
        'fa0c6e86-dbd9-11ea-a252-027d6fa66c86': ['Male', 'Female'],
        '709e603a-df93-11ee-a18b-0248b00e5bcd': [
          'Very Mild',
          'Mild',
          'Moderate',
          'Severe',
          'Very Severe',
        ],
      },
    },
    15404: {
      title:
        'Based on your answers, we have matched you to a CRM software supplier best suited to you:',
      cardUrl: '/cpc-card-assets/cpc-card-crm-uk.html',
      questions: {
        'e13b0eaf-6aca-11ef-a18b-0248b00e5bcd': ['1-4'],
        '1c28c558-6acb-11ef-a18b-0248b00e5bcd': ['1', '2'],
      },
    },
  },
  'production-na': {
    6506: {
      title:
        'Based on your answers, we have matched you to a CRM software supplier best suited to you:',
      cardUrl: '/cpc-card-assets/cpc-card-crm-us.html',
      questions: {
        'a7e862c0-fbe9-11e5-9ebe-22000b0a2127': ['1-4'],
        '52ecb588-6b9e-11e7-bbea-02e4563f24a3': ['1', '2'],
      },
    },
    6369: {
      title:
        'Based on your answers we have matched you to a field service software supplier best suited to you:',
      cardUrl: '/cpc-card-assets/cpc-card-field-service-software-us.html',
      questions: {
        'b162bb18-a343-11e5-824b-22000a699fb3': ['1 - 4'],
        '86bd6b1d-77eb-11ea-9e05-027d6fa66c86': ['1', '2'],
      },
    },
    6494: {
      title:
        'Based on your answer we have matched you to the following website builders:',
      cardUrl: '/cpc-card-assets/cpc-card-web-design-us.html',
      questions: {
        '0f3b4df1-dcc9-11ec-a6b2-062f1bcd6de3': ['Build my own website'],
      },
    },
    6732: {
      title:
        'Based on your answers, you’re eligible to buy Eargo’s product online. Click ‘Visit Store’ to go to the Eargo shop.',
      cardUrl: '/cpc-card-assets/cpc-card-hearing-aids-us.html',
      questions: {
        '8b7f2fe0-8eb3-11e9-9e05-027d6fa66c86': ['45 or under', '46 to 55'],
        'c5dd8a2d-8eb3-11e9-9e05-027d6fa66c86': ['Yes', 'No'],
      },
    },
  },
};

export default cpcCardConfig;
